/* istanbul ignore file */ /* this file is not used or will be deleted in other branches */
// @ts-nocheck
import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import ReactTooltip from 'react-tooltip';
import { Info2 as ExclamationCircle } from '@td-client-frontend/icons';

interface CheckboxModalProps {
  className?: string;
  colorType?: 'default' | 'blue';
  disabled?: boolean;
  checked?: boolean;
  onHandleChangeList?: any;
  tooltip?: string;
  label: string;
  disabled?: boolean;
  product: string;
}
export const CheckboxModal = ({
  className = '',
  colorType = 'default',
  name,
  label,
  checked,
  onHandleChangeList,
  tooltip,
  disabled,
  product,
  ...props
}: CheckboxModalProps & React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>) => {
  const [isChecked, setIsChecked] = useState(checked);

  const onHandleChange = () => {
    setIsChecked(!isChecked);
    if (onHandleChangeList) {
      onHandleChangeList(!isChecked, product);
    }
  };

  // when checked is being updated by props
  useEffect(() => {
    setIsChecked(checked);
  }, [checked]);

  return (
    <div className="flex justify-start items-start">
      <div
        className={clsx(
          'field-with-icons rounded w-5 h-5 flex flex-shrink-0 justify-center items-center mr-2 relative p-1',
          props.disabled && 'opacity-50 cursor-default',
          isChecked && colorType === 'blue' ? 'bg-blue-80' : '',
          className
        )}
      >
        <input
          {...props}
          type="checkbox"
          data-testid="checkboxinput-input"
          className="opacity-0 absolute h-full w-full"
          name={name}
          id={name}
          onChange={onHandleChange}
          checked={isChecked}
          disabled={disabled}
        />
        <svg
          viewBox="0 0 20 20"
          className={clsx(
            'fill-current w-5 h-5 text-primary-500 pointer-events-none',
            !isChecked && 'hidden',
            colorType === 'blue' && 'fill-white'
          )}
        >
          <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
        </svg>
      </div>
      <div
        className={`${
          tooltip ? 'flex' : ''
        } font-effra text-black-default block tracking-wide text-sm font-normal mt-1 mb-2`}
      >
        <label className="font-normal">{label}</label>
        {tooltip && (
          <>
            <ExclamationCircle
              data-for="spp-tooltip"
              data-tip={tooltip}
              className="-mt-2 fill-current text-primary-500"
            />
            <ReactTooltip
              id="spp-tooltip"
              className="tooltip-custom"
              place="right"
              effect="solid"
              type="light"
              multiline
              border
              borderColor="#5b2f91"
            />
          </>
        )}
      </div>
    </div>
  );
};
